<script setup lang="ts">
import { RouterLink } from 'vue-router'
import { TAOBAO_PURCHASE_URL } from '../purchase'

const steps = [
  ['在淘宝完成购买', '由淘宝处理登录与付款'],
  ['运营人工核对', '只记录必要的脱敏订单标识'],
  ['通过约定渠道发码', '授权码不可推导、可撤销'],
  ['客户端联网激活', '显示授权类型、设备额度和有效期'],
]
</script>

<template>
  <div class="page-wrap purchase-page">
    <header class="page-heading">
      <h1>购买后人工发码，客户端完成激活</h1>
    </header>
    <section class="purchase-layout">
      <article class="purchase-card ml-card">
        <span class="ml-pill">淘宝官方购买入口</span>
        <h2>购买授权资格</h2>
        <p>商品价格、可选规格与实际权益以淘宝商品页展示为准。</p>
        <ul>
          <li>参与 M0 / M1 封闭测试</li>
          <li>支持 Windows 与 macOS</li>
          <li>人工授权码与售后协助</li>
          <li>不承诺永久获得未来大版本</li>
        </ul>
        <a data-purchase-link class="ml-button" :href="TAOBAO_PURCHASE_URL" target="_blank" rel="noopener noreferrer">前往淘宝购买</a>
      </article>
      <article class="steps-card ml-card">
        <h2>购买与激活流程</h2>
        <ol>
          <li v-for="([title, detail], index) in steps" :key="title">
            <span :class="{ teal: index === steps.length - 1 }">{{ index + 1 }}</span>
            <div>
              <strong>{{ title }}</strong>
              <small>{{ detail }}</small>
            </div>
          </li>
        </ol>
      </article>
    </section>
    <div class="purchase-help">
      <RouterLink class="ml-button ml-button--secondary" to="/help">查看激活帮助</RouterLink>
    </div>
  </div>
</template>

<style scoped>
.purchase-layout {
  display: grid;
  grid-template-columns: 420px 1fr;
  gap: 42px;
}

.purchase-card,
.steps-card {
  padding: 34px;
}

.purchase-card {
  border: 2px solid var(--ml-brand);
}

.purchase-card h2 {
  margin: 34px 0 12px;
  font-size: 28px;
}

.purchase-card p,
.purchase-card li,
.steps-card small {
  color: var(--ml-text-secondary);
}

.purchase-card ul {
  display: grid;
  gap: 22px;
  min-height: 245px;
  margin: 34px 0;
  padding: 0;
  list-style: none;
}

.purchase-card li::before {
  margin-right: 12px;
  color: var(--ml-success);
  content: '✓';
}

.purchase-card .ml-button {
  width: 100%;
}

.steps-card ol {
  display: grid;
  gap: 30px;
  margin: 32px 0 0;
  padding: 0;
  list-style: none;
}

.steps-card li {
  display: flex;
  align-items: center;
  gap: 20px;
}

.steps-card li > span {
  display: grid;
  flex: 0 0 42px;
  height: 42px;
  place-items: center;
  border-radius: 12px;
  background: var(--ml-brand-soft);
  color: var(--ml-brand);
  font-weight: 800;
}

.steps-card li > span.teal {
  background: var(--ml-teal-soft);
  color: var(--ml-teal);
}

.steps-card small {
  display: block;
  margin-top: 8px;
}

.purchase-help {
  display: flex;
  justify-content: flex-end;
  margin-top: 26px;
}

@media (max-width: 820px) {
  .purchase-layout {
    grid-template-columns: 1fr;
  }
}
</style>
